module.exports = __webpack_public_path__ + "static/reduction_in_CV_event-7522e3411988bbc90fd406ea49467060.png";